import PropTypes from 'prop-types';
import Hamburger from "../Hamburger/Hamburger";
import "./AppBar.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AppBar(_ref) {
  let {
    id = '',
    style = {},
    iconElementLeft = '',
    iconStyleLeft = {},
    iconElementRight = '',
    iconStyleRight = {},
    onHamburgerIconClick = null,
    opened
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-center bg-brand-blue text-white justify-between p-3 relative w-full z-10 app-bar",
    "data-testid": id,
    id: id,
    style: style,
    role: "banner",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex flex-auto items-center",
      children: [onHamburgerIconClick ? /*#__PURE__*/_jsx(Hamburger, {
        id: id,
        "data-testid": id,
        className: "mr-8",
        opened: opened,
        onMenuClick: onHamburgerIconClick
      }) : null, /*#__PURE__*/_jsx("div", {
        className: "flex flex-auto",
        style: iconStyleLeft,
        children: iconElementLeft
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex flex-initial",
      style: iconStyleRight,
      children: iconElementRight
    })]
  });
}
AppBar.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** The custom element to be displayed on the left side of the app bar. */
  iconElementLeft: PropTypes.node,
  /** Override the inline-styles of the element displayed on the left side of the app bar. */
  iconStyleLeft: PropTypes.object,
  /** The custom element to be displayed on the right side of the app bar. */
  iconElementRight: PropTypes.node,
  /** Override the inline-styles of the element displayed on the right side of the app bar. */
  iconStyleRight: PropTypes.object,
  /** Function for when the left hamburger icon is selected via a touch tap. */
  onHamburgerIconClick: PropTypes.func,
  /** If true, App Bar will recognize as opened */
  opened: PropTypes.bool.isRequired
};
export default AppBar;
//# sourceMappingURL=AppBar.js.map